import { Link, Theme, useMediaQuery } from "@mui/material";

import { ReactComponent as LogoSvg } from "assets/images/logo/logo.svg";

export const InvitaeNavLeft = () => {
  const xs = useMediaQuery((theme: Theme) => theme.breakpoints.down('sm'));

  return (
    <Link href="https://www.archerdx.com" style={{ display: "flex" }}>
      <LogoSvg height={xs ? 40 : 80} width={"auto"} />
    </Link>
  );
};
